export enum CommonActionTypes {
  INIT = "@@INIT",
  LOCATION_CHANGE = "@@router/LOCATION_CHANGE",
}
